
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Clock, Globe } from 'lucide-react';
import Section from '../ui/Section';
import QuoteForm from '../QuoteForm';

const CTA = () => {
  const { t } = useTranslation();
  const [isQuoteFormOpen, setIsQuoteFormOpen] = useState(false);
  
  return (
    <Section id="cta" background="gradient">
      <div className="relative max-w-4xl mx-auto text-center">
        {/* Background */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        </div>
        
        {/* Content */}
        <div className="bg-white/10 border border-white/10 rounded-3xl p-12 md:p-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            {t('cta.title')}
          </h2>
          
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          
          <button
            onClick={() => setIsQuoteFormOpen(true)}
            className="px-8 py-4 bg-primary hover:bg-primary-light text-background font-semibold rounded-xl transition-all inline-flex items-center gap-2"
          >
            {t('cta.button')}
            <ArrowRight className="w-5 h-5" />
          </button>
          
          {/* Info */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-10 pt-10 border-t border-white/10">
            <div className="flex items-center gap-2 text-gray-400">
              <Clock className="w-4 h-4" />
              <span className="text-sm">{t('cta.response_time')}</span>
            </div>
            
            <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-600" />
            
            <div className="flex items-center gap-2 text-gray-400">
              <Globe className="w-4 h-4" />
              <span className="text-sm">{t('cta.timezone')}</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Quote Form Modal */}
      <QuoteForm isOpen={isQuoteFormOpen} onClose={() => setIsQuoteFormOpen(false)} />
    </Section>
  );
};

export default CTA;
